import { Intercom, showNewMessage } from '@intercom/messenger-js-sdk';

export default () => {
  Intercom({
    app_id: window.INTERCOM_ID,
    hide_default_launcher: true,
  });

  document.querySelectorAll('.open-intercom').forEach((element) => {
    element.addEventListener('click', () => {
      const menu = element.closest('.header__menu');
      (menu?.querySelector('ul > li.drop-down-menu__help > div > .nav-item') as HTMLDivElement | null)?.click();
      (menu?.querySelector('ul > li.drop-down-menu__category--help > div > .nav-item') as HTMLDivElement | null)?.click();
      showNewMessage('');
    });
  });
};
